import type { SendFeedbackRequest } from "@newfungame/contracts";

/** То, что игрок вводит в окне отзыва; контекст подставляет `app/start.ts`. */
export type FeedbackInput = Pick<SendFeedbackRequest, "type" | "text" | "contact">;

export interface FeedbackActions {
  /** Отзыв игрока, ошибку отдаёт окну (`app/start.ts`). */
  sendFeedback(input: FeedbackInput): Promise<void>;
}

export const defaults: FeedbackActions = {
  sendFeedback: async () => {},
};

declare module "../actions" {
  interface WindowActions extends FeedbackActions {}
}
